<template>
  <div class="v-file-input">
    <input type="file" @change="handleFileChange" ref="fileInput" :multiple="multiple" :accept="accept" style="display: none;" />
    <label class="file-label" @click="openFileInput">
      {{placeholder}}
    </label>
  </div>
</template>

<script>
export default {
  name: 'VFileInput',
  props: {
    accept: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Choose a file'
    }
  },
  methods: {
    handleFileChange(event) {
      const files = event.target.files;
      this.$emit('input', this.multiple ? files : files[0]);
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
  }
};
</script>

<style scoped>

.file-label {
  display: inline-block;
  padding: 8px 16px;
  background-color: #666adf;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
}
</style>
